window.Ply = window.Ply || {};

Ply.ready = function (fn) {
  if (document.readyState != 'loading'){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

Ply.makeArray = function(collection) {
  var array = [];
  for (var i = 0; i < collection.length; i++) {
    array.push(collection[i]);
  }
  return array;
};

Ply.addClass = function(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    el.className += ' ' + className;
  }
};

Ply.removeClass = function(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  }
}

Ply.byProp = function(propName, propValue) {
  return function(item) { return item[propName] === propValue };
};

Ply.byId = function(id) {
  return Ply.byProp("id", id);
};
